var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('eqify-page',{attrs:{"no-title-text":"","actions":[
      {name:_vm.$t('competition.create.label'), icon:'campground',to:'/competitions/create',variant:'primary', multiFederation:true, checkPermission: _vm.canCreateCompetition}
  ]}},[_c('calendar-component',{attrs:{"title":"Wedstrijden","with-year":true,"search-callback":_vm.searchCallback,"save-search-data":true,"save-storage-prefix":"competition"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }